<template>
  <div>
    <div v-if="!validationComplete">
      <submission-spinner></submission-spinner>
    </div>
    <div v-if="showEmailSignInForm">
      <email-login-form :badLink="true" />
    </div>
    <div class="py-16 px-4 overflow-hidden" v-if="showRegistrationForm">
      <post-login-registration-form></post-login-registration-form>
    </div>
  </div>
</template>

<script>
import { auth } from "../utils/firebase";
import EmailLoginForm from "../components/EmailLoginForm";
import SubmissionSpinner from "../components/SubmissionSpinner";
import PostLoginRegistrationForm from "../components/PostLoginRegistrationForm";
export default {
  name: "PostLogin",
  components: { PostLoginRegistrationForm, SubmissionSpinner, EmailLoginForm },
  data() {
    return {
      showRegistrationForm: false,
      validationComplete: false,
      validEmailLink: false,
      validEmailInLink: false,
      email: "",
      signInError: null
    };
  },
  methods: {
    validate() {
      // Check if the link is valid
      if (!auth.isSignInWithEmailLink(window.location.href)) {
        this.validEmailLink = false;
        this.validationComplete = true;
        // Check if the link is valid
        console.warn("Invalid email link");
        return;
      } else {
        this.validEmailLink = true;
      }

      // first we are going to try local storage
      const localStorageEmail = window.localStorage.getItem("emailForSignIn");
      if (localStorageEmail) {
        this.email = localStorageEmail;
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        this.email = urlParams.get("email");
      }

      if (!this.email) {
        this.validEmailInLink = false;
        this.validationComplete = true;
        return;
      } else {
        this.validEmailInLink = true;
      }

      this.validationComplete = true;
    },
    signIn() {
      const email = this.email;
      const link = window.location.href;
      auth
        .signInWithEmailLink(email, link)
        .then(result => {
          // If this is a new user then we want them to complete their registration form
          if (result.additionalUserInfo.isNewUser) {
            this.showRegistrationForm = true;
            return;
          }

          // If this is an old user then we want to check if they have a display name
          if (!result.user.displayName || result.user.displayName === "") {
            this.showRegistrationForm = true;
            return;
          } else {
            this.$router.push("/home");
          }
        })
        .catch(error => {
          // Some error occurred, you can inspect the code: error.code
          // Common errors could be invalid email and invalid or expired OTPs.
          console.error(error);
          this.signInError = error.code;
        });
    }
  },
  computed: {
    showEmailSignInForm() {
      return this.validationComplete && this.signInError;
    }
  },
  mounted() {
    this.validate();
    this.signIn();
  }
};
</script>

<style scoped></style>
